module.exports = __webpack_public_path__ + "assets/img/4icon.897748b0.png";